var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUndoIcon = function SvgUndoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16.2479893px",
    height: "14.3731054px",
    viewBox: "0 0 16.2479893 14.3731054",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.5.6-Queue-/-Registration---revert-to-upcoming",
    transform: "translate(-1072.877011, -768.814395)",
    fill: "#3776AB"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.Organisms/06.Toast-banner/Default",
    filter: "url(#filter-1)",
    transform: "translate(1053.000000, 740.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03.Molecules/01.Text/02.Sub/02.With-icon/Discription",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5,19.1875 C19.3075809,19.1875 19.1258799,19.0988995 19.0074219,18.9472657 C18.1144532,17.8039063 17.2859375,16.9214844 16.1433594,16.3300781 C15.0859375,15.784375 13.7578125,15.4996094 12,15.4464844 L12,18.5625 C11.9992383,18.811833 11.8503554,19.0368601 11.6211768,19.1350673 C11.3919982,19.2332746 11.1263739,19.1858715 10.9453125,19.0144532 L4.07031246,12.4519531 C3.94685371,12.3340273 3.8770107,12.1707295 3.8770107,12 C3.8770107,11.8292705 3.94685371,11.6659727 4.07031246,11.5480469 L10.9453125,4.98554684 C11.1263739,4.81412846 11.3919982,4.76672538 11.6211768,4.86493267 C11.8503554,4.96313995 11.9992383,5.188167 12,5.43749997 L12,8.57656248 C14.8960938,8.70976561 17.0539063,9.78398436 18.4199219,11.7746094 C19.5515625,13.4234375 20.125,15.7070313 20.125,18.5625 C20.125,18.907678 19.845178,19.1875 19.5,19.1875 Z",
    id: "arrow-undo"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUndoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/undo-icon.09a6f3a3.svg";
export { ForwardRef as ReactComponent };